var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGradientDesignCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 250,
    viewBox: "0 0 400 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0.25H375C388.669 0.25 399.75 11.331 399.75 25V225C399.75 238.669 388.669 249.75 375 249.75H25C11.331 249.75 0.25 238.669 0.25 225V25C0.25 11.331 11.331 0.25 25 0.25Z",
    fill: "black",
    stroke: "url(#paint0_linear_324_1289)",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M374.475 7H182.475C136.075 7 172.142 30.6667 195.975 42.5C220.642 48.8333 271.075 76.3 275.475 135.5C279.875 194.7 359.975 176.833 399.475 160.5C398.975 136.333 398.275 80.4 399.475 50C400.675 19.6 383.308 8.66667 374.475 7Z",
    fill: "url(#paint1_linear_324_1289)",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_324_1289",
    x1: 312.984,
    y1: 223.907,
    x2: 240.066,
    y2: 19.1434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_324_1289",
    x1: 256.475,
    y1: 7.5,
    x2: 437.475,
    y2: 117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DED1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientDesignCard);
export default __webpack_public_path__ + "static/media/gradient-design-card.84a8347309e270a8d21861fdeabf1cf5.svg";
export { ForwardRef as ReactComponent };